import styled from 'styled-components'
import { Container, Row, Col } from 'react-bootstrap'
import Spinner from 'react-bootstrap/Spinner'
import styles from '../utility/styles'
import MapListItem from './MapListItem'
import { useMapState } from '../state/context'
import { setSelectedPin } from '../state/actions'
import Text from './shared/Text'
import { useMemo } from 'react'

const Wrapper = styled(Container)`
	width: ${styles.spacing.chargerListFull};
	background-color: ${styles.colors.background};
	height: 100lvh;
	border-right: 1px solid var(--tz-hairline, rgba(255, 255, 255, 0.08));
	overflow: scroll;
	@media screen and ${styles.breakpoints.desktop} {
		height: 180px;
		width: 100vw;
		margin-top: 0;
		border-right: none;
		border-bottom: 1px solid var(--tz-hairline, rgba(255, 255, 255, 0.08));
	}
	@media screen and (max-width: 450px), screen and (max-height: 450px) {
		display: none;
	}
`

const StyledCol = styled(Col)`
	padding: 48px 24px;
	height: 100%;
	@media screen and ${styles.breakpoints.desktop} {
		padding: 24px 0;
		display: flex;
		flex-direction: row;
	}
`

const Skeleton = styled.div`
	height: 110px;
	background-color: var(--tz-wash, rgba(255, 255, 255, 0.04));
	width: 100%;
	margin-bottom: 8px;
	border-radius: 8px;
`

const SpinnerRow = styled.div`
	flex: 1;
	display: flex;
	justify-content: center;
	margin: 8px 0;
`

const StyledSpinner = styled(Spinner)`
	margin: auto;
`

const EmptyWrapper = styled.div`
	display: flex;
	flex: 1;
	height: calc(100lvh - 96px);
	justify-content: center;
	align-items: center;
	@media screen and ${styles.breakpoints.desktop} {
		height: 100%;
		width: 100vw;
	}
	@media screen and (max-width: 450px), screen and (max-height: 450px) {
		display: none;
	}
`

/**
 *
 * @param {{ navigate:(id:string,longitude:number,latitude:number)=>void }} props
 * @returns
 */
export default function MapList({ navigate }) {
	const [
		{
			chargersInViewport,
			fetchingPins,
			pinsFetchError,
			selectedPin,
			runningInitialFetch,
			showNonTeslaOnly,
		},
		dispatch,
	] = useMapState()

	const chargers = useMemo(
		() =>
			showNonTeslaOnly
				? chargersInViewport?.filter(pin => pin.sc_non_tesla)
				: chargersInViewport,
		[chargersInViewport, showNonTeslaOnly]
	)

	const onClick = (id, longitude, latitude) => {
		navigate(id, longitude, latitude)
	}

	const onHover = id => {
		dispatch(setSelectedPin(id))
	}

	return (
		<Wrapper fluid='850px'>
			{(fetchingPins && !chargers?.length) || runningInitialFetch ? (
				<StyledCol>
					{Array.from(Array(10)).map((_, i) => (
						<Skeleton key={`skeleton_${i+1}`} />
					))}
				</StyledCol>
			) : (
				<StyledCol>
					{chargers?.length ? (
						chargers.map(pin => (
							<Row key={pin.id} id={pin.id}>
								<MapListItem
									title={pin.name}
									subtitle={pin.brand?.display}
									power={pin.power_kw}
									stallsTotal={pin.stalls?.total}
									stallsAvailable={pin.stalls?.available}
									type={pin.power_kw > 150 ? '250kW' : '150kW'}
									{...{ onHover, onClick, selectedPin }}
									id={pin.id}
									longitude={pin.location?.lon}
									latitude={pin.location?.lat}
								/>
							</Row>
						))
					) : (
						<EmptyWrapper>
							<Text.Heading type='h5'>{pinsFetchError || 'No Chargers Found'}</Text.Heading>
						</EmptyWrapper>
					)}
					{fetchingPins && (
						<SpinnerRow>
							<StyledSpinner variant='secondary' />
						</SpinnerRow>
					)}
				</StyledCol>
			)}
		</Wrapper>
	)
}
